<template lang="pug">
.menu_list
  .each(v-for="(item, i) in navs" :class="{'isOpen':item.isOpen}")
    .main_menu(@click="toggleOpen(item, i)")
      .img.fl(:style="{backgroundPosition: idxMain === i ? item.bgImgTopActive : item.bgImgTop}")
      span(:style="{color: idxMain === i ? '#282729' : '#666'}") {{item.name}}
      .fr(v-if="item.list && item.list.length > 0")
        i.iconfont.icon-caidan-shouqi(v-if="item.isOpen")
        i.iconfont.icon-caidan-zhankai(v-else)
    .list(v-if="item.list && item.list.length > 0")
      .sub_menu(
        v-for="(it, j) in item.list" :key="j"
        @click="navClick(it, i, j)"
        :class="{'cur': curNav == it.url}"
      )
        div.clearfix.l2_div
          span(v-if="it.local" class="icon_box")
            img(class="local_icon" :src="it.local")
          i.fl.iconfont(v-else :class="it.icon")
          span {{it.name}}

</template>

<script>
import { SpecialPageCode, ZhengZhouMode } from "@/utils/config";
// import Dbbg from "@/assets/dbbg.png";

const navMap = {
  SY: {
    name: "首页",
    url: "/home",
    bgImgTop: "0 -77px",
    bgImgTopActive: "0 -97px"
  },
  TGGL: { name: "推广管理", bgImgTop: "0 -238px", bgImgTopActive: "0 -258px" },
  DWTF: {
    name: "点位投放",
    url: "/putOrder",
    icon: "icon-kuaisuzhinengtoufang"
  },
  DTTF: { name: "地图投放", url: "/putOrderMap", icon: "icon-ditutoufang" },
  WLGGTF: {
    name: "网络广告投放",
    url: "/putOrderWifi",
    icon: "icon-wifiguanggaotoufang"
  },
  SSGGTF: {
    name: "实时广告投放",
    url: "/putOrderH5Realtime",
    icon: "icon-wifiguanggaotoufang"
  },
  XLGGTF: {
    name: "限量广告投放",
    url: "/putOrderTimeLimit",
    icon: "icon-zhibodingdan"
  },
  CPRPLUS: {
    name: "CPR+广告投放",
    url: "/putCprplus",
    icon: "icon-cprplus"
  },
  GGSC: { name: "广告素材", url: "/orderVideo", icon: "icon-chuangyisucai" },
  H5SCBJQ: { name: "H5素材编辑器", url: "/H5Edit", icon: "icon-bianjiqi" },

  DDZX: { name: "订单中心", bgImgTop: "0 -276px", bgImgTopActive: "0 -296px" },
  WDDD: { name: "我的订单", url: "/orderList", icon: "icon-wodedingdan" },

  CWGL: { name: "财务管理", bgImgTop: "0 -355px", bgImgTopActive: "0 -375px" },
  ZXCZ: { name: "在线充值", url: "/recharge", icon: "icon-chongzhi" },
  XXCZ: {
    name: "线下充值",
    url: "/rechargeOffline",
    icon: "icon-xianxiachongzhi"
  },
  CZJL: { name: "充值记录", url: "/rechargeList", icon: "icon-chongzhijilu" },
  XFJL: { name: "消费记录", url: "/spentList", icon: "icon-xiaofeijilu" },
  LSMX: { name: "流水明细", url: "/waterDetail", icon: "icon-liushuimingxi" },

  SJBG: { name: "数据报告", bgImgTop: "0 -394px", bgImgTopActive: "0 -414px" },
  DDSJ: { name: "订单数据", url: "/orderReport", icon: "icon-dingdanshuju" },
  // DBBG: { name: "对比报告", url: "/contrastReport", local: Dbbg }, // 鉴于第三方图标库iconfont临时不可用,此菜单使用img特殊处理
  DBBG: { name: "对比报告", url: "/contrastReport", icon: "icon-dbbg" },

  ZHZX: { name: "账号中心", bgImgTop: "0 -435px", bgImgTopActive: "0 -455px" },
  KHXX: { name: "客户信息", url: "/accountInfo", icon: "icon-zhanghaoxinxi" },
  XGSJH: {
    name: "修改手机号",
    url: "/modifyPhone",
    icon: "icon-xiugaishoujihao"
  },
  XGMM: { name: "修改密码", url: "/modifyPassword", icon: "icon-xiugaimima" },
  YHQ: { name: "优惠券", url: "/coupon", icon: "icon-youhuiquan" },
  YJFK: { name: "意见反馈", url: "/feedback", icon: "icon-yijianfankui" },
  WDYJ: { name: "我的佣金", url: "/commission", icon: "icon-wodeyongjin" }
}

// const onlyPut = [
//   {
//     name: "推广管理",
//     bgImgTop: "0 -238px",
//     bgImgTopActive: "0 -258px",
//     code: "TGGL",
//     list: [
//       { name: "点位投放", url: "/putOrder", icon: "icon-kuaisuzhinengtoufang", code: "DWTF", children: [] }
//     ],
//     isOpen: false
//   }
// ]

// 演示专用 id 相关控制
// const actionUidNav = {
//   15595: onlyPut,
//   2002609: onlyPut,
//   2000831: [
//     {
//       name: "推广管理",
//       bgImgTop: "0 -238px",
//       bgImgTopActive: "0 -258px",
//       code: "TGGL",
//       list: [
//         { name: "点位投放", url: "/putOrder", icon: "icon-kuaisuzhinengtoufang", code: "DWTF", children: [] }
//       ],
//       isOpen: false
//     },
//     {
//       name: "订单中心",
//       bgImgTop: "0 -276px",
//       bgImgTopActive: "0 -296px",
//       code: "DDZX",
//       list: [
//         { name: "我的订单", url: "/orderList", icon: "icon-wodedingdan", code: "WDDD", children: [] }
//       ],
//       isOpen: false
//     }
//   ]
// }

// // CPR+广告投放权限账号
// const cprPlusAuth = [15581, 15394, 15578, 15393, 13049, 2003223, 15261]

export default {
  name: "LeftNav",
  data() {
    return {
      navs: [],
      idxMain: -1, // 当前选中的一级菜单索引
      curNav: '',
      speUserGuids: (process.env.VUE_APP_SPEUSERIDS || "").replace(/\s/g, "").split(",")
    };
  },
  computed: {
    customer() {
      return this.$store.state.customer.customerInfo;
    },
    adUser() {
      return this.$store.state.customer.userInfo;
    },
    isSpeUser() {
      return (
        this.speUserGuids.length &&
        this.adUser &&
        this.adUser.id &&
        this.speUserGuids.indexOf(this.adUser.id + "") > -1
      )
    },
    validCus() {
      // 所属客户是否生效状态(审核通过且未过期)
      if (this.customer && this.customer.advertiserType)
        return this.customer.checkStatus === 1;
      return false;
    }
  },
  watch: {
    "$store.state.customer.userInfo": {
      immediate: true,
      handler(v) {
        if (!v || !v.roleId) return
        // 路由数据处理
        // if (actionUidNav[v.id]) return this.handleActionUserNav(v.id);
        // else if (v.roleId) this.getNavs(v.roleId, v.id);
        this.getNavs(v.roleId, v.id)
      }
    },
    "$route.path"(v) {
      this.handleOpen(v);
    }
  },
  methods: {
    // handleActionUserNav(id) { // 演示专用id相关处理
    //   this.navs = actionUidNav[id];
    //   let curPath = this.$route.path;
    //   if (curPath === "/" || curPath === "/home") this.goUrl("/putOrder");
    //   this.handleOpen(curPath);
    // },
    async getNavs(roleId, uid) {
      const res = await this.fetch(
        `/customer/api/v3/roles/${roleId}/menus`,
        {
          platform: 0,
          userId: uid
        },
        "get"
      )
      if (!res || !res.data || !res.data.length) return
      this.navs = res.data.map(el => {
        const seniorM = navMap[el.code] // 一级菜单
        if (!seniorM) return null
        el.url = seniorM.url
        el.list = (el.children || []).map(ele => {
          const subM = navMap[ele.code]
          if (!subM) return null
          ele.url = subM.url // 菜单路由以前端配置为准
          return { ...subM, ...ele }
        }).filter(e => e)
        return { ...seniorM, ...el, isOpen: false }
      }).filter(e => e)
      this.handleOpen(this.$route.path)
    },
    handleOpen(path) {
      this.curNav = path;
      let num = 0;
      this.navs.forEach((el, i) => {
        if (el.url && el.url == path) {
          this.idxMain = i;
          num++;
          return;
        } else if (el.list && el.list.map(el => el.url).indexOf(path) > -1) {
          this.idxMain = i;
          this.navs.forEach(item => {
            item.isOpen = false;
          });
          el.isOpen = true;
          num++;
          return;
        }
      });
      if (num === 0) this.idxMain = -1; // 全部不高亮
    },
    toggleOpen(item, i) {
      this.$emit("clickMainMenu", item);
      let isOpen = item.isOpen;
      this.navs.forEach(item => {
        item.isOpen = false;
      });
      item.isOpen = !isOpen;
      if (!item.list || item.list.length == 0) {
        if (item.url) {
          this.idxMain = i;
          this.curNav = item.url;
          this.goUrl(item.url);
        }
      } else {
        this.navClick(item, i);
      }
    },
    navClick(it, i) {
      if (!it.url) return;
      if (it.url === this.$route.path) return;
      if (SpecialPageCode.indexOf(it.code) > -1 && !this.validCus) {
        return this.messageTip("请完成资质认证后重试", 2)
      }
      this.idxMain = i;
      this.goUrl(it.url);
      this.curNav = it.url;
    }
  }
};
</script>

<style lang="sass" scoped>
.close .menu_list
  overflow-y: visible !important
.menu_list
  overflow-y: auto
  padding: 10px 20px
  height: calc(100% - 250px)

.each
  position: relative
  margin-bottom: 10px
  &.isOpen .list
    height: auto
    opacity: 1
  .list
    height: 0
    overflow: hidden
    transition: all .8s
    opacity: 0

.main_menu
  height: 50px
  line-height: 50px
  font-weight: 600
  cursor: pointer
  i
    color: #E994AD
  .img
    width: 20px
    height: 20px
    background-image: url("../assets/menus.png")
    background-size: 100% auto
    margin-top: 15px
    margin-right: 6px

.sub_menu
  display: block
  height: 40px
  padding: 5px 20px
  font-size: 13px
  cursor: pointer
  &.cur
    .l2_div
      color: #FF3973
      border: 1px solid #FF3973
      &:hover
        border: 1px solid #FF3973
        background-color: #fff

  > div
    border-radius: 25px
    padding-left: 16px
    line-height: 30px
    &:hover
      background: rgba(40,39,41,.05)
    i
      font-size: 22px
      color: #E994AD
      margin-right: 5px

  .icon_box
    display: inline-block
    width: 22px
    margin-right: 5px
    text-align: center
    .local_icon
      width: 16px
      height: 16px
      margin-bottom: 1px
      vertical-align: middle
</style>
